import { Input, Select, Submit, Textarea } from "./services/components";
import { useGQLForm } from "./services/hooks";
import { useEffect } from "react";

const DataQuery = {
  author: ['users?id=eq.$id', false]
}
const CreateQuery = ['users', 'POST']
const UpdateQuery = ['users?id=eq.$id', 'PATCH']

const parseData = (data) => ({
  ...data,
});

export default () => {
  const {
    register,
    handleSubmit,
    onSubmit,
    error,
    data,
    idExists,
  } = useGQLForm({
    DataQuery,
    CreateQuery,
    UpdateQuery,
    parseData,
    createKey: "createAuthor",
    path: "authors",
  });

  useEffect(() => {
    register("author", {
      value: 1,
    });
  }, []);

  if (error || (!data && idExists)) return <div>Loading...</div>;

  console.log(data)
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="container px-4 mx-auto py-8">
        <div className="text-lg">
          {idExists ? "Edycja użytkownika" : "Tworzenie użytkownika"}
          <br />
        </div>

        <Input
          label="Nazwa"
          placeholder="Wpisz nazwę"
          {...register("fname")}
          defaultValue={idExists ? data.author.fname : ""}
        />

        <Textarea
          label="Treść autora"
          placeholder="Treść autora"
          {...register("biography")}
          defaultValue={idExists ? data.author.biography : ""}
        />

        <Textarea
          label="Treść autora"
          placeholder="Treść autora"
          {...register("biography_long")}
          defaultValue={idExists ? data.author.biography_long : ""}
        />

        <Submit />
      </div>
    </form>
  );
};
